import React, { useEffect, useState } from "react";
import cssClasses from "./AddBankDetailsModal.module.css";
import { Box, Modal } from "@mui/material";
import Close from "../../Icons/Close";
import Button from "../../../Subcomponents/Button";
import CustomInput from "../../../Subcomponents/CustomInput";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  height: "fit-Content",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
};

const AddBankDetailsModal = ({
  open,
  handleClose,
  isEdit,
  handleSave,
  selectedBank,
}) => {
  const [bankData, setBankData] = useState({
    bankName: "",
    ifscCode: "",
    branchName: "",
    city: "",
  });

  const [helperText, setHelperText] = useState({
    bankName: "",
    ifscCode: "",
    branchName: "",
    city: "",
  });

  useEffect(() => {
    if (selectedBank !== null) {
      const payload = {
        bankName: selectedBank?.bankName,
        ifscCode: selectedBank?.ifscCode,
        branchName: selectedBank?.branchName,
        city: selectedBank?.city,
      };
      setBankData(payload);
    }
  }, [selectedBank]);

  const handleBankName = (e) => {
    setBankData((pre) => {
      pre.bankName = e;
      return { ...pre };
    });
    if (!e.trim().length) {
      setHelperText((pre) => {
        pre.bankName = "Bank name can not be empty!";
        return { ...pre };
      });
    } else if (/\d/.test(e) === true) {
      setHelperText((pre) => {
        pre.bankName = "Bank name can not contain numbers!";
        return { ...pre };
      });
    } else if (!/^[A-Za-z0-9 ]+$/.test(e)) {
      setHelperText((pre) => {
        pre.bankName = "Bank name can not contain special characters!";
        return { ...pre };
      });
    } else if (e && e !== "" && e.trim().length) {
      setHelperText((pre) => {
        pre.bankName = "";
        return { ...pre };
      });
    } else {
      setHelperText((pre) => {
        pre.bankName = "Please enter bank name!";
        return { ...pre };
      });
    }
  };

  const handleBranchName = (e) => {
    setBankData((pre) => {
      pre.branchName = e;
      return { ...pre };
    });
    if (!e.trim().length) {
      setHelperText((pre) => {
        pre.branchName = "Branch name can not be empty!";
        return { ...pre };
      });
    } else if (/\d/.test(e) === true) {
      setHelperText((pre) => {
        pre.branchName = "Branch name can not contain numbers!";
        return { ...pre };
      });
    } else if (!/^[A-Za-z0-9 ]+$/.test(e)) {
      setHelperText((pre) => {
        pre.branchName = "Branch name can not contain special characters!";
        return { ...pre };
      });
    } else if (e && e !== "" && e.trim().length) {
      setHelperText((pre) => {
        pre.branchName = "";
        return { ...pre };
      });
    } else {
      setHelperText((pre) => {
        pre.branchName = "Please enter branch name!";
        return { ...pre };
      });
    }
  };

  const handleISFCCode = (e) => {
    setBankData((pre) => {
      pre.ifscCode = e.replace(/\s+/g, "").toUpperCase();
      return { ...pre };
    });
    if (!e.trim().length) {
      setHelperText((pre) => {
        pre.ifscCode = "ISFC code can not be empty!";
        return { ...pre };
      });
    } else if (e?.length < 11 && e !== "") {
      setHelperText((pre) => {
        pre.ifscCode = "IFSC Code should have 11 Character!";
        return { ...pre };
      });
    } else if (/^\d+$/.test(e)) {
      setHelperText((pre) => {
        pre.ifscCode = "IFSC Code can't contains only numbers!";
        return { ...pre };
      });
    } else if (/^[a-zA-Z]+$/.test(e)) {
      setHelperText((pre) => {
        pre.ifscCode = "IFSC Code can't contains only alphabets!";
        return { ...pre };
      });
    } else if (!/^[A-Za-z0-9 ]+$/.test(e)) {
      setHelperText((pre) => {
        pre.ifscCode = "ISFC code can not contain special characters!";
        return { ...pre };
      });
    } else if (e && e !== "" && e?.length === 11 && e.trim().length) {
      setHelperText((pre) => {
        pre.ifscCode = "";
        return { ...pre };
      });
    } else {
      setHelperText((pre) => {
        pre.ifscCode = "Please enter valid ifsc code!";
        return { ...pre };
      });
    }
  };

  const handleCityName = (e) => {
    setBankData((pre) => {
      pre.city = e;
      return { ...pre };
    });
    if (!e.trim().length) {
      setHelperText((pre) => {
        pre.city = "City name can not be empty!";
        return { ...pre };
      });
    } else if (/\d/.test(e) === true) {
      setHelperText((pre) => {
        pre.city = "City name can not contain numbers!";
        return { ...pre };
      });
    } else if (!/^[A-Za-z0-9 ]+$/.test(e)) {
      setHelperText((pre) => {
        pre.city = "City name can not contain special characters!";
        return { ...pre };
      });
    } else if (e && e !== "" && e.trim().length) {
      setHelperText((pre) => {
        pre.city = "";
        return { ...pre };
      });
    } else {
      setHelperText((pre) => {
        pre.city = "Please enter city!";
        return { ...pre };
      });
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexCol}>
                <Box className={cssClasses.flexRow}>
                  <Box className={cssClasses.HeaderTitle}>
                    {isEdit ? "Edit Bank" : "Add Bank"}
                  </Box>
                </Box>
              </Box>
              <Box
                ml={"auto"}
                mt={1}
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              >
                <Close width={"1.2rem"} height={"1.2rem"} />
              </Box>
            </Box>
          </Box>

          <Box width={"100%"} height={"49%"} overflow={"auto"}>
            <Box
              paddingX={"3rem"}
              backgroundColor={"#F9FAFB"}
              display={"flex"}
              justifyContent={"space-between"}
              gap={"2rem"}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "3rem",
                  justifyContent: "space-evenly",
                }}
              >
                <div>
                  <CustomInput
                    handleChange={(e) => {
                      handleBankName(e);
                    }}
                    label={"Bank Name"}
                    value={bankData?.bankName}
                    placeholder={"Enter Bank Name"}
                    inputType={"text"}
                    helperText={helperText?.bankName}
                    mandatory={true}
                  />
                </div>
                <div>
                  <CustomInput
                    handleChange={(e) => {
                      handleBranchName(e);
                    }}
                    label={"Branch Name"}
                    value={bankData?.branchName}
                    placeholder={"Enter Branch Name"}
                    inputType={"text"}
                    helperText={helperText?.branchName}
                    mandatory={true}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "3rem",
                  justifyContent: "space-evenly",
                }}
              >
                <div>
                  <CustomInput
                    handleChange={(e) => {
                      handleISFCCode(e);
                    }}
                    style={{ textTransform: "uppercase" }}
                    label={"Bank Ifsc code"}
                    value={bankData?.ifscCode}
                    placeholder={"Enter IFSC Code"}
                    inputType={"text"}
                    helperText={helperText?.ifscCode}
                    mandatory={true}
                  />
                </div>
                <div>
                  <CustomInput
                    handleChange={(e) => {
                      handleCityName(e);
                    }}
                    label={"City"}
                    value={bankData?.city}
                    placeholder={"Enter City"}
                    inputType={"text"}
                    helperText={helperText?.city}
                    mandatory={true}
                  />
                </div>
              </div>
            </Box>
          </Box>

          <Box className={cssClasses.FooterDiv}>
            <Box
              className={cssClasses.flexRow}
              style={{ justifyContent: "end" }}
            >
              {isEdit && (
                <Box width={"fit-Content"}>
                  <Button
                    style={{
                      fontSize: "1.6rem",
                      lineHeight: "2.4rem",
                      color: "rgba(52, 64, 84, 1)",
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      borderRadius: "0.8rem",
                    }}
                    padding={"0.65rem 3.2rem"}
                    btnName={"Delete"}
                    clicked={() => {
                      handleSave(bankData, isEdit, true);
                    }}
                  />
                </Box>
              )}
              <Box width={"fit-Content"}>
                <Button
                  style={{
                    fontSize: "1.6rem",
                    lineHeight: "2.4rem",
                    color: "#FFF",
                    backgroundColor: "#006AFF",
                    borderRadius: "0.8rem",
                  }}
                  padding={"0.65rem 3.2rem"}
                  disable={
                    helperText?.bankName !== "" ||
                    helperText?.ifscCode !== "" ||
                    helperText?.branchName !== "" ||
                    helperText?.city !== "" ||
                    bankData?.bankName === "" ||
                    bankData?.ifscCode === "" ||
                    bankData?.branchName === "" ||
                    bankData?.city === ""
                  }
                  btnName={isEdit ? "Save" : "Add"}
                  clicked={() => {
                    handleSave(bankData, isEdit, false);
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default AddBankDetailsModal;
